{
  "pageTitle": "Dobrodošli",
  "morning": "Dobro jutro",
  "afternoon": "Dobar dan",
  "evening": "Dobra večer",
  "up": "Raste",
  "down": "Pada",
  "totalInvoices": "Ukupno računa",
  "totalPaid": "Ukupno plaćeno",
  "pendingProcessing": "U obradi",
  "avgMonthly": "Prosječno mjesečno",
  "comboTitle": "Najnoviji sažetak računa",
  "noInvoice": "Nema računa",
  "noData": "Još nema podataka o računima",
  "comboEmptyHint": "Dodajte adresu i pokrenite skupljanje da vidite rezultate ovdje.",
  "viewActions": "Idi na Akcije"
}
